import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PASSWORD_FORMAT_PROPS, PASSWORD_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  generation: { label: "Generation", color: "#FDF2F8", textColor: "#9D174D" },
  validation: { label: "Validation", color: "#FFF7ED", textColor: "#C2410C" },
};

function PasswordList() {
  const [password, setPassword] = useState("");
  const [passwordFilled, setPasswordFilled] = useState("Mahender");
  const [passwordDisabled, setPasswordDisabled] = useState("");
  const [passwordFilledDisabled, setPasswordFilledDisabled] =
    useState("Mahender");

  return (
    <div>
      <div className="grid grid-cols-4 gap-1 my-5 mb-30">
        <div>
          <FormFieldSet
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="Password"
            passwordFormat={{
              // Make sure this is spelled correctly
              base: "Mahender",
            }}
          />
          {password}
        </div>
        <div>
          <FormFieldSet
            value={passwordFilled}
            onChange={(e) => setPasswordFilled(e.target.value)}
            type="password"
            placeholder="Password"
            passwordFormat={{
              // Make sure this is spelled correctly
              base: "Mahender",
            }}
            shadow={true}
          />
          {passwordFilled}
        </div>
        <div>
          <FormFieldSet
            value={passwordDisabled}
            onChange={(e) => setPasswordDisabled(e.target.value)}
            type="password"
            placeholder="Password"
            passwordFormat={{
              // Make sure this is spelled correctly
              base: "Mahender",
            }}
            disabled={true}
          />
          {passwordDisabled}
        </div>
        <div>
          <FormFieldSet
            value={passwordFilledDisabled}
            onChange={(e) => setPasswordFilledDisabled(e.target.value)}
            type="password"
            placeholder="Password"
            passwordFormat={{
              // Make sure this is spelled correctly
              base: "Mahender",
            }}
            disabled={true}
            shadow={true}
          />
          {passwordFilledDisabled}
        </div>
      </div>


      <PropsTable
        data={PASSWORD_PROPS}
        title="Password — Props Reference"
        typeLabel='type="Password"'
        categories={CATEGORIES}
        />
      <PropsTable
        data={PASSWORD_FORMAT_PROPS}
        title="passwordFormat — Options"
        typeLabel="passwordFormat={{ ... }}"
        categories={CATEGORIES}
      />
    </div>
  );
}

export default PasswordList;
